import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReactPaginate from 'react-paginate'
import styled from 'styled-components'
import api from '../../../../api'
import Responsive from '../../../../assets/config/Responsive'
import CarIcon from '../../../../assets/icons/JSX/CarIcon'
import CarSmallIcon from '../../../../assets/icons/JSX/CarSmallIcon'
import DoubleRightIcon from '../../../../assets/icons/JSX/DoubleRightIcon'
import FilterIcon from '../../../../assets/icons/JSX/FilterIcon'
import TravelIcon from '../../../../assets/icons/JSX/TravelIcon'
import TravelSmallIcon from '../../../../assets/icons/JSX/TravelSmallIcon'
import Colors from '../../../../assets/styles/Colors'
import Dropdown from '../../../../components/v2/Dropdown'
import EmptySreen from '../../../../components/EmptySreen'
import Loader from '../../../../components/Loader'
import { Transation } from '../../../../domain/types'
import { useDebounce } from 'use-debounce'
import Input from '../../../../components/v2/Input'
import WelcomerIcon from '../../../../assets/icons/JSX/WelcomerIcon'
import WelcomerSmallIcon from '../../../../assets/icons/JSX/WelcomerSmallIcon'
import PetIcon from '../../../../assets/icons/JSX/PetIcon'
import PetSmallIcon from '../../../../assets/icons/JSX/PetSmallIcon'
import { useAppSelector } from '../../../../store'
import { AppState } from '../../../../store/appSlice'
//
//
const Transactions = () => {
  //
  const { t } = useTranslation()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const [showFilters, setShowFilters] = useState<boolean>(false)
  //
  const [filterFields, setFilterFields] = useState<Partial<Transation> | null>({
    page: 1,
  })
  //
  const [insuredDebounceName] = useDebounce(filterFields?.insuredName, 1000)
  //
  const { data: userTransactions, isLoading: isUserTransactionLoading } = api.useGetUserTransactionsQuery({
    insuranceType: filterFields?.insuranceType || '',
    companyId: filterFields?.companyId || undefined,
    insuredName: insuredDebounceName || '',
    status: filterFields?.status || '',
    limit: 10,
    page: filterFields?.page as number,
  })
  //
  const { data: companies, isFetching: isCompaniesLoading } = api.useGetFilterCompaniesQuery(undefined)
  //
  const _setFilterFields = (field: keyof Transation, value: any) => {
    setFilterFields({
      ...filterFields,
      [field]: value,
    })
  }
  //
  //
  const sortedTransactions = userTransactions ? [...userTransactions?.orders].reverse() : []
  //
  const pageCount =
    userTransactions &&
    userTransactions.meta &&
    userTransactions.meta.total &&
    Math.ceil(userTransactions?.meta?.total / 10)
  //
  //
  //
  const MainLoading = isCompaniesLoading || isUserTransactionLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      {(userTransactions && userTransactions.orders && userTransactions.orders.length >= 1) ||
      showFilters ||
      filterFields?.status ||
      filterFields?.insuredName ||
      filterFields?.insuranceType ||
      filterFields?.companyId ? (
        <>
          <Filter>
            <ScreenTitle>{t('transactionHistory')}</ScreenTitle>
            <button onClick={() => setShowFilters(!showFilters)}>
              Filter
              <FilterIcon />
            </button>
          </Filter>
          {showFilters ? (
            <DropdownWrapper>
              <Dropdown
                title={t('productCategory')}
                options={[
                  ...[
                    {
                      slug: 'travel-outside-georgia',
                      name: 'სამოგზაურო დაზღვევა',
                      translations: {
                        ge: {
                          name: 'სამოგზაურო დაზღვევა',
                        },
                        en: {
                          name: 'Travel Insurance',
                        },
                      },
                    },
                    {
                      slug: 'welcomer-to-georgia',
                      name: 'შიდა ტურების დაზღვევა',
                      translations: {
                        ge: {
                          name: 'შიდა ტურის დაზღვევა',
                        },
                        en: {
                          name: 'Local Tour Insurance',
                        },
                      },
                    },
                    {
                      slug: 'tpl',
                      name: 'ავტოპასუხისმგებლობის დაზღვევა',
                      translations: {
                        ge: {
                          name: 'ავტოპასუხისმგებლობის დაზღვევა',
                        },
                        en: {
                          name: 'Motor Liability Insurance',
                        },
                      },
                    },
                    {
                      slug: 'pet',
                      name: 'შინაური ცხოველის დაზღვევა',
                      translations: {
                        ge: {
                          name: 'შინაური ცხოველის დაზღვევა',
                        },
                        en: {
                          name: 'Pet Insurance',
                        },
                      },
                    },
                  ],
                ].map((c) => ({
                  value: c.slug,
                  label: c.translations[lang]?.name.toUpperCase(),
                }))}
                placeholder={''}
                onChange={(obj) => _setFilterFields('insuranceType', obj.value)}
              />

              <Dropdown
                title={t('company')}
                options={
                  companies
                    ? [
                        ...companies.map((company) => ({
                          value: company.id,
                          label: company.title,
                        })),
                      ]
                    : []
                }
                placeholder={''}
                onChange={(obj) => _setFilterFields('companyId', obj.value)}
              />

              <Input
                id="inured-name"
                name="inured-name"
                label={t('insured')}
                width={'fullWidth'}
                type="text"
                value={filterFields?.insuredName || ''}
                onChange={(value) => _setFilterFields('insuredName', value)}
              />

              <Dropdown
                title={t('status')}
                options={[
                  ...['paid', 'pending'].map((s) => ({
                    value: s,
                    label: s.toUpperCase(),
                  })),
                ]}
                placeholder={''}
                onChange={(obj) => _setFilterFields('status', obj.value)}
              />
            </DropdownWrapper>
          ) : null}

          <TransactionsStyle>
            <TitleSection>
              <Title></Title>
              <Title>{t('product')}</Title>
              <Title>{t('company')}</Title>
              <Title>{t('insured')}</Title>
              <Title>{t('date')}</Title>
              <Title>{t('paidAmount')}</Title>
              {/* <Title>{t('transactionId')}</Title> */}
              <TitleHideInMobile>{t('status')}</TitleHideInMobile>
            </TitleSection>
            {sortedTransactions?.map((item, index) => (
              <ContentStyles key={index}>
                <Title>
                  {item.insuranceType === 'Travel' ? (
                    <TravelIconStyle />
                  ) : item.insuranceType === 'Tpl' ? (
                    <CarIconStyle />
                  ) : item.insuranceType === 'Welcomer' ? (
                    <WelcomerIconStyle />
                  ) : item.insuranceType === 'Pet' ? (
                    <PetIconStyle />
                  ) : null}
                </Title>
                <Title>{item.insuranceType}</Title>
                <Title>{item.companyName}</Title>
                <Title>{item.insuredName}</Title>
                <Title>{item.paidAt}</Title>
                <Title>{item.amount}</Title>
                {/* <Title>{item.transactionId}</Title> */}
                <TitleHideInMobile>
                  <StatusSpan>
                    {item.status}
                    {item.status && (
                      <StatusBall
                        style={{
                          backgroundColor:
                            item.status === 'paid'
                              ? Colors.java
                              : item.status === 'pending'
                              ? Colors.Primary
                              : Colors.primaryRed,
                        }}
                      />
                    )}
                  </StatusSpan>
                </TitleHideInMobile>
              </ContentStyles>
            ))}
            <br />
            {sortedTransactions?.map((item, index) => (
              <ContentStylesMobile key={index}>
                <div>
                  <Title>
                    {item.insuranceType === 'Travel' ? (
                      <TravelSmallIconStyle />
                    ) : item.insuranceType === 'Tpl' ? (
                      <CarSmallIconStyle />
                    ) : item.insuranceType === 'Welcomer' ? (
                      <WelcomerSmallIconStyle />
                    ) : item.insuranceType === 'Pet' ? (
                      <PetSmallIconStyle />
                    ) : null}
                    {item.insuranceType}
                  </Title>
                  <Title>
                    <StatusSpan>
                      {item.status && (
                        <StatusBall
                          style={{
                            backgroundColor:
                              item.status === 'paid'
                                ? Colors.java
                                : item.status === 'pending'
                                ? Colors.Primary
                                : Colors.primaryRed,
                          }}
                        />
                      )}
                    </StatusSpan>
                  </Title>
                </div>
                <div>
                  <Title>{t('policy')}#:</Title>
                  <Title>{item.policyNumber}</Title>
                </div>
                <div>
                  <Title>{t('date')}:</Title>
                  <Title>{item.paidAt}</Title>
                </div>
                <div>
                  <Title>{t('paidAmount')}:</Title>
                  <Title>{item.amount}</Title>
                </div>
              </ContentStylesMobile>
            ))}
          </TransactionsStyle>

          {userTransactions && userTransactions.orders && userTransactions.orders.length >= 1 ? (
            <>
              <br />
              <CustomPaginationWrapper>
                <ReactPaginate
                  breakLabel={'...'}
                  forcePage={(filterFields?.page as number) - 1}
                  nextLabel={<RightIcon />}
                  onPageChange={(event) => _setFilterFields('page', event.selected + 1)}
                  pageRangeDisplayed={1}
                  pageCount={pageCount || 0}
                  previousLabel={<LeftIcon />}
                  // renderOnZeroPageCount={null}
                />
              </CustomPaginationWrapper>
            </>
          ) : null}
        </>
      ) : (
        <EmptySreen
          bigText={t('noTransactions')}
          smallDescription={t('noActivePolicyDescription')}
          buttonText={t('priceCalculation')}
          buttonUrl="/category"
        />
      )}
    </Wrapper>
  )
}
//
//
// styles
const RightIcon = styled(DoubleRightIcon)`
  color: ${Colors.primaryRed};
  height: 15px;
`
const LeftIcon = styled(DoubleRightIcon)`
  transform: rotate(180deg);
  color: ${Colors.primaryRed};
  height: 15px;
`
const CustomPaginationWrapper = styled.div`
  margin-block: 20px;
  display: grid;
  place-items: center;
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    margin-bottom: 0px;
    li {
      user-select: none;
      font-size: 14px;
      line-height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background-color: transparent;
      color: var(--text-color);
      height: 30px;
      width: 30px;
      cursor: pointer;
      margin-inline: 1px;

      a {
        width: 100%;
        text-align: center;
        display: grid;
        place-items: center;
      }

      &.disabled {
        opacity: 0.6;
      }

      &.break {
        a {
          height: 100%;
          margin-top: -8px;
          color: ${Colors.primaryRed};
        }
      }
      &.selected {
        background-color: ${Colors.primaryRed};
        color: ${Colors.white};
      }
    }
  }

  ${Responsive.mobile} {
    ul {
      li {
        margin: 0 5px;
        font-size: 14px;
        height: 24px;
        width: 24px;
      }
    }
  }
`
const ContentStylesMobile = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`
const ContentStyles = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  padding-top: 40px;
  margin-top: 40px;
  box-shadow: 160px -2px 0px ${Colors.grey};
  :nth-child(1) {
    box-shadow: none;
  }
  &:nth-child(2) {
    padding-top: 20px;
    margin-top: 0px;
    border-top: 0px;
    box-shadow: none;
  }
  div {
    text-align: left;
    :first-child {
      text-align: center;
    }
    :nth-child(8) {
      text-align: center;
    }
    :last-child {
      text-align: center;
    }
  }
  /*  */
  ${Responsive.laptop} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    box-shadow: 100px -2px 0px ${Colors.grey};
    div {
      :nth-child(7) {
        text-align: center;
      }
    }
  }
`
const TransactionsStyle = styled.div`
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  background-color: ${Colors.white};
  border-radius: 8px;
  overflow: hidden;
  &:first-child {
    margin-bottom: 55px;
  }
  ${Responsive.mobile} {
    padding-inline: 24px;
    &:first-child {
      margin-bottom: 26px;
    }
  }
`
const Filter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  /* open filter button */
  button {
    display: flex;
    align-items: center;
    border: 1px solid ${Colors.primaryBlack};
    border-radius: 4px;
    background-color: transparent;
    height: 48px;
    padding: 0px 25px;
    /* open filter button icon */
    svg {
      height: 10px;
      margin-left: 10px;
    }
  }
`
const ScreenTitle = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
const Wrapper = styled.div`
  margin-top: 20px;
`
const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 3rem 3rem;
  padding: 30px 60px 20px 60px;
  background-color: white;
  margin-bottom: 30px;
  ${Responsive.laptop} {
    gap: 1rem 2rem;
  }
  ${Responsive.tablet} {
    gap: 1rem 2rem;
  }
  ${Responsive.mobile} {
    padding: 20px 30px;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 0rem 2rem;
  }
`
const TitleSection = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  text-align: right;
  padding-inline: 20px;
  margin-bottom: 40px;
  div {
    color: ${Colors.primaryGrey};
    text-align: left;
    :nth-child(8) {
      text-align: center;
    }
    :last-child {
      text-align: center;
    }
  }
  /*  */
  ${Responsive.mobile} {
    display: none;
  }
  ${Responsive.tablet} {
    margin-bottom: 10px;
  }
`
const Title = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  user-select: none;
  /* background-color: red; */
  /* responsive */
  ${Responsive.laptop} {
    font-size: 12px;
  }
  ${Responsive.tablet} {
    font-size: 12px;
    padding-left: 0px;
  }

  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`
const TitleHideInMobile = styled(Title)`
  ${Responsive.mobile} {
    display: none;
  }
`
const TravelIconStyle = styled(TravelIcon)`
  margin-top: -15px;
`
const CarIconStyle = styled(CarIcon)`
  margin-top: -15px;
`
const WelcomerIconStyle = styled(WelcomerIcon)`
  margin-top: -15px;
`
const PetIconStyle = styled(PetIcon)`
  margin-top: -15px;
`
const TravelSmallIconStyle = styled(TravelSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const CarSmallIconStyle = styled(CarSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const WelcomerSmallIconStyle = styled(WelcomerSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const PetSmallIconStyle = styled(PetSmallIcon)`
  ${Responsive.mobile} {
    margin-right: 20px;
  }
`
const StatusBall = styled.span`
  height: 7px;
  width: 7px;
  border-radius: 50px;
  background-color: ${Colors.primaryGreen};
  user-select: none;
  pointer-events: none;
  padding: 0px !important;
  position: absolute;
  margin-left: 5px;
  margin-top: 7px;
  ${Responsive.mobile} {
    margin-top: 6px;
  }
  ${Responsive.mobile} {
    margin-top: 0px;
  }
`
const StatusSpan = styled.span`
  ${Responsive.mobile} {
    margin-left: -13px;
    position: relative;
  }
`

export default Transactions
